<template>
  <div class="form-group">
    <div class="input-group input-group-btnAndInput col-xs-12"
          v-click-outside="() => { displaySearchOptions = false; displayMessagePanel = false; cleanSearchResult(); }">
        <span v-show="showSearchOptionPanel" class="input-group-btn">
          <button class="btn" :class="[buttonStyle]" type="button" @click="displaySearchOptions = true">{{currentSearchOption.Name}}</button>
        </span>
        <ul class="dropdown-menu" v-show="displaySearchOptions">
          <li v-for="o in searchOptions"><a @click="currentSearchOption = o; displaySearchOptions = false;">{{o.Name}}</a></li>
        </ul>
        <input type="text" v-model="searchKeyword" @keyup.enter="searchProductsAndVariants(searchKeyword)" class="form-control text-box single-line" />
        <a class="input-group-addon" @click="searchProductsAndVariants(searchKeyword)"><i class="ion-ios-search-strong"></i></a>
        <ul class="dropdown-menu" v-show="displayMessagePanel"><li><a>{{displayMessage}}</a></li></ul>
        <ul class="dropdown-menu" v-show="searchResult.length > 0">
          <li v-for="(item, i) in searchResult" class="base-text">
            <a v-if="item.CanBePurchased" v-on:click="itemSelected(item)">
              <div class="col-xs-3 col-sm-1">
                <img class="lazypreload lazyloaded" :src="item.FeaturedImageLandscapePaddedSrc" />
              </div>
              <p style="white-space:normal;">
                <b>{{item.Sku}} {{item.DisplayName}}</b>
                <span>{{item.DisplayPricePriceOnly}}</span>
              </p>
            </a>
            <div v-else>
              <div class="col-xs-3 col-sm-1">
                <img class="lazypreload lazyloaded" :src="item.FeaturedImageLandscapePaddedSrc" />
              </div>
              <p style="white-space:normal;">
                <b>{{item.Sku}} {{item.DisplayName}}</b>
                <br />
                <strong class="alert-danger">
                  {{messageToDisplayWhenAProductCannotBePurchased}}
                </strong>
              </p>
            </div>
            <hr v-if="i < searchResult.length - 1" />
          </li>
          <li class="text-center"><a v-show="searchMoreUrl" :href="searchMoreUrl" :class="[buttonStyle]"><b :class="[buttonStyle]">View More</b></a></li>
        </ul>
    </div>
  </div>
</template>
<script>
  import { ProductService } from "../../Models/Product/ProductService";

  export default {
    name: "AutocompleteLookupProductsAndVariants",
    props: {
      buttonStyle: {
        type: String,
      },
      showSearchOptionPanel: {
        type: Boolean,
      },
      defaultSearchOptionKey: {
        type: String,
        default: () => 'KeyWords'
      },
      productSearchPageUrl: {
        type: String,
      },
      messageToDisplayWhenAProductCannotBePurchased: {
        type: String,
      },
      maxItemsInResult: {
        type: Number,
        default: () => 3
      }
    },
    data() {
      return {
        searchOptions: [{ Key: 'Skus', Name: 'SKU', Type: 'WrapArray' }, { Key: 'KeyWords', Name: 'KeyWords', Type: 'String' }],
        currentSearchOption: { Key: 'KeyWords', Name: 'KeyWords', Type: 'String' },
        displaySearchOptions: false,
        searchKeyword: '',
        searchResult: [],
        searchMoreUrl: '',
        displayMessagePanel: false,
        displayMessage: ''
      };
    },
    watch: {
      searchKeyword: function (n, o) {
        const tempStr = n;
        this.searchResult = [];
        setTimeout(() => {
          //console.log("Keyword check: " + this.searchKeyword + " - "+ tempStr);
          if (this.searchKeyword === tempStr) {
            this.searchProductsAndVariants(this.searchKeyword)
          }
        }, 1000);
      },
      defaultSearchOptionKey: function (n, o) {
        this.setSearchOption(n);
      },
    },
    mounted() {
      //console.log("showSearchOptionPanel", this.showSearchOptionPanel);
      //console.log("buttonStyle", this.buttonStyle);
      //console.log("maxItemsInResult", this.maxItemsInResult);

      this.setSearchOption(this.defaultSearchOptionKey);
    },
    methods: {
      setSearchOption (key) {
        const defaultSearchOptions = this.searchOptions.filter(v => v.Key === key);
        if (defaultSearchOptions.length > 0) {
          this.currentSearchOption = defaultSearchOptions[0];
        }
      },
      searchProductsAndVariants(keyword) {
        if (keyword === '') {
          this.searchResult = [];
          this.displayMessagePanel = false;
          this.displayMessage = '';
          return;
        }

        const productService = new ProductService();
        let searchParams = { StoreId: 1 };
        searchParams[this.currentSearchOption.Key] = this.convertValue(keyword, this.currentSearchOption.Type);

        this.displayMessagePanel = true;
        this.displayMessage = 'Loading...';
        productService.autocompleteLookupProductsAndVariants(searchParams)
          .then(({ data }) => {
            if (data.length > this.maxItemsInResult) {
              this.searchMoreUrl = `${this.productSearchPageUrl}/?keywords=${keyword}&searchType=Product`
            }
            else {
              this.searchMoreUrl = '';
            }

            this.searchResult = data.slice(0, this.maxItemsInResult);

            if (this.searchResult.length === 0) {
              this.displayMessagePanel = true;
              this.displayMessage = 'No Result.';
            }
            else {
              this.displayMessagePanel = false;
              this.displayMessage = '';
            }
          });
      },
      itemSelected(item) {
        this.$emit('item-selected', item);
        this.displayMessagePanel = false;
        this.displayMessage = '';
        this.searchResult = [];
      },
      getPriceItems(str) {
        const priceItemsObj = JSON.parse(str);
        return priceItemsObj.PriceItems;
      },
      convertValue(obj, type) {
        const convertStates = {
          WrapArray: function (v) {
            return [v];
          },
          String: function (v) {
            return v.toString();
          }
        };
        return convertStates[type] && convertStates[type](obj);
      },
      cleanSearchResult: function () {
        //console.log("cleanSearchResult");
        this.searchResult = [];
      }
    }
  };
</script>
<style scoped>
  .dropdown-menu {
    left: 0;
    right: 0;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// EcomCore/Components/Products/AutocompleteLookupProductsAndVariants.vue